import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SocialProofBar } from '../components/SocialProofBar';
import { ProofSection } from '../components/ProofSection';
import { WhyThisDevice } from '../components/WhyThisDevice';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { OptionsTable } from '../components/OptionsTable';
import { SimpleSteps } from '../components/SimpleSteps';
import { TimelineSection } from '../components/TimelineSection';
import { CloseSection } from '../components/CloseSection';
import { FAQ } from '../components/FAQ';
import { ReviewsSection } from '../components/ReviewsSection';
import { CTAButton } from '../components/CTAButton';
import { useCart } from '../contexts/CartContext';
import { crownControlReviews } from '../utils/reviewsData';
export function CrownControlPage() {
  const {
    addToCart
  } = useCart();
  return <main className="w-full min-h-screen bg-white" data-id="element-343">
      <Header data-id="element-344" />
      <Hero data-id="element-345" />
      <SocialProofBar data-id="element-346" />
      <ProofSection data-id="element-347" />
      <WhyThisDevice data-id="element-348" />
      <GuaranteeSection data-id="element-349" />
      <OptionsTable data-id="element-350" />
      <SimpleSteps data-id="element-351" />
      <TimelineSection data-id="element-352" />
      <CloseSection data-id="element-353" />
      <FAQ data-id="element-354" />
      <ReviewsSection reviews={crownControlReviews} data-id="element-355" />

      {/* Footer */}
      <footer className="w-full bg-gray-900 py-12 px-4" data-id="element-356">
        <div className="max-w-7xl mx-auto text-center" data-id="element-357">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-358">CrownControl™</h3>
          <p className="text-gray-400 mb-6" data-id="element-359">
            The Non-Hormonal Protocol That Shows If Your Hair Can Still Come
            Back
          </p>
          <p className="text-sm text-gray-500 mb-8" data-id="element-360">
            FDA-Cleared Device Class · 180-Day Guarantee · No Hormones · No
            Surgery
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-361">
            <CTAButton variant="primary" onClick={addToCart} ariaLabel="Start the 180-Day CrownControl Protocol" data-id="element-362">
              Start the 180-Day CrownControl Protocol
            </CTAButton>
            <p className="text-sm text-gray-400" data-id="element-363">
              One-time payment of $497 · Free shipping · 180-Day Guarantee
            </p>
          </div>
        </div>
      </footer>
    </main>;
}